/**
 * Paleta de cores padronizada para indicadores de status (bolinhas/dots) em tabelas.
 */
export const STATUS_COLOR_PALETTE = {
    green: '#10b981',
    yellow: '#f59e0b',
    red: '#ef4444',
    orange: '#f97316',
    blue: '#3b82f6',
    teal: '#14b8a6',
    purple: '#8b5cf6',
    grey: '#9ca3af',
    dark: '#374151'
};
